export const CAMPAIGN = {
  title: "Healthy India Pledge Wall",
  dates: "August 8 – 14, 2026",
  tagline: "One nation. One pledge. A healthier India.",
};

export const ORG = {
  name: "BlueCross Lifesciences",
  logo: "/bluecross.png",
};

// Campaign target shown as a countdown/progress on the live wall.
export const PLEDGE_TARGET = 20000;

// Brand logo images (frontend/public/Logos/) for the running strip at the
// bottom of the live wall.
export const BRAND_LOGOS = [
  "Asset 1@4x.png", "Asset 2@4x.png", "Asset 4@4x.png", "Asset 5@4x.png",
  "Asset 6@4x.png", "Asset 8@4x.png", "Asset 9@4x.png", "Asset 10@4x.png",
  "Asset 13@4x.png", "Asset 17@4x.png", "Asset 18@4x.png",
].map((f) => `/Logos/${encodeURIComponent(f)}`);

// Text fallback for the brand strip (kept for reference / reuse elsewhere).
export const BRAND_STRIP = [
  { name: "Xstan", detail: "Telmisartan 20 mg. / 40 mg.", color: "#1DA850" },
  { name: "Cilniblu", detail: "Cilnidipine 5 mg. / 10 mg.", color: "#E31E24" },
  { name: "Proglif 10/25", detail: "Empagliflozin 10 mg. / 25 mg.", color: "#00A651" },
  { name: "P-RD", detail: "Pantoprazole 40 mg. GR + Domperidone 30 mg. (10 mg. IR + 20 mg. PR)", color: "#1B75BB" },
  { name: "R-RD", detail: "Rabeprazole GR 20 mg. + Domperidone SR 30 mg.", color: "#8B1A1A" },
];

// Ready-made pledges the doctor can pick on the pledge form, plus the option
// to write their own (final texts from the client).
export const STANDARD_PLEDGES = [
  {
    id: "affordable-care",
    title: "Pledge 1",
    text: "I stand for affordable care. I stand for better adherence.",
  },
  {
    id: "adherence",
    title: "Pledge 2",
    text: "I pledge to support long-term adherence through evidence-based and affordable treatment choices.",
  },
  {
    id: "independence-day",
    title: "Pledge 3",
    text: "This Independence Day, I pledge to support effective, affordable and sustainable treatment for every patient.",
  },
];

export const SPECIALTIES = [
  "General Medicine", "Cardiology", "Pediatrics", "Orthopedics", "Gynecology",
  "Dermatology", "Neurology", "Oncology", "Psychiatry", "Radiology",
  "General Surgery", "ENT", "Ophthalmology", "Anesthesiology", "Pulmonology",
  "Nephrology", "Gastroenterology", "Endocrinology", "Dentistry", "Family Medicine",
  "Emergency Medicine", "Pathology", "Urology", "Other",
];

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
  "Ladakh", "Lakshadweep", "Puducherry",
];

// Tile-map layout: [col, row, abbreviation]
export const STATE_TILES = {
  "Jammu and Kashmir": [3, 0, "JK"],
  "Ladakh": [4, 0, "LA"],
  "Punjab": [2, 1, "PB"],
  "Himachal Pradesh": [3, 1, "HP"],
  "Uttarakhand": [4, 1, "UK"],
  "Chandigarh": [2, 2, "CH"],
  "Haryana": [3, 2, "HR"],
  "Sikkim": [6, 2, "SK"],
  "Arunachal Pradesh": [7, 2, "AR"],
  "Rajasthan": [1, 3, "RJ"],
  "Delhi": [3, 3, "DL"],
  "Uttar Pradesh": [4, 3, "UP"],
  "Bihar": [5, 3, "BR"],
  "Assam": [6, 3, "AS"],
  "Nagaland": [7, 3, "NL"],
  "Gujarat": [0, 4, "GJ"],
  "Madhya Pradesh": [3, 4, "MP"],
  "Jharkhand": [5, 4, "JH"],
  "West Bengal": [6, 4, "WB"],
  "Meghalaya": [7, 4, "ML"],
  "Manipur": [8, 4, "MN"],
  "Dadra and Nagar Haveli and Daman and Diu": [1, 5, "DN"],
  "Maharashtra": [2, 5, "MH"],
  "Chhattisgarh": [4, 5, "CG"],
  "Odisha": [5, 5, "OD"],
  "Tripura": [7, 5, "TR"],
  "Mizoram": [8, 5, "MZ"],
  "Goa": [2, 6, "GA"],
  "Telangana": [3, 6, "TG"],
  "Andhra Pradesh": [4, 6, "AP"],
  "Karnataka": [2, 7, "KA"],
  "Puducherry": [4, 7, "PY"],
  "Lakshadweep": [0, 8, "LD"],
  "Kerala": [2, 8, "KL"],
  "Tamil Nadu": [3, 8, "TN"],
  "Andaman and Nicobar Islands": [6, 8, "AN"],
};

export const PLEDGE_POINTS = [
  "I pledge to promote preventive health check-ups.",
  "I pledge to spread awareness about diabetes prevention.",
  "I pledge to encourage a healthy lifestyle.",
  "I pledge to help defeat hypertension.",
  "I pledge to support a tobacco-free India.",
];

export const FAQS = [
  {
    q: "Who can take the Healthy India Pledge?",
    a: "Any registered medical practitioner across India — doctors, surgeons, and specialists with a valid Medical Council registration number.",
  },
  {
    q: "Is my registration verified?",
    a: "For this campaign the pledge is self-declared. You provide your Medical Council Registration Number in good faith. No external verification is performed at launch.",
  },
  {
    q: "Will I get a certificate?",
    a: "Yes. A personalized participation certificate with a unique Certificate ID is generated instantly and can be downloaded immediately after you pledge.",
  },
  {
    q: "I lost my certificate. Can I download it again?",
    a: "Absolutely. Use the 'Retrieve Certificate' page and enter your Registration Number and Email to download it again anytime.",
  },
  {
    q: "What is the Asia Book of Records attempt?",
    a: "This campaign aims to set a record for the largest healthcare pledge by medical professionals in India, running from August 8–14, 2026.",
  },
];
